import React from "react";
import { formatIDR } from "@/lib/api";

export function calcTotals(items, defaultRate = 0.11, discountGlobal = 0, dppNilaiLain = false, vatRate = 0.12) {
  let sub = 0, tax = 0;
  (items || []).forEach((it) => {
    const qty = Number(it.quantity) || 0, price = Number(it.price) || 0;
    const pct = Number(it.discount_percent) || 0;
    const disc = pct > 0 ? qty * price * pct / 100 : (Number(it.discount) || 0);
    const line = Math.max(0, qty * price - disc);
    sub += line;
    const rate = it.tax_rate ?? defaultRate;
    // PMK 131/2024: PPN = tarif 12% × (11/12 × DPP) → efektif 11% dari harga jual
    tax += (dppNilaiLain && rate > 0) ? line * (11 / 12) * vatRate : line * rate;
  });
  const g = Math.min(Number(discountGlobal) || 0, sub);
  const factor = sub > 0 ? (sub - g) / sub : 1;
  const net = sub - g;
  return { sub: net, tax: tax * factor, total: net + tax * factor, dppOther: dppNilaiLain ? net * 11 / 12 : 0 };
}

export default function TaxRegsPanel({ taxRegs, value = [], onChange, subtotal, testidPrefix = "taxreg" }) {
  if (!taxRegs || taxRegs.length === 0) return null;
  const selected = value || [];
  const toggle = (id, checked) =>
    onChange(checked ? [...selected, id] : selected.filter((x) => x !== id));
  const totalDed = taxRegs
    .filter((r) => selected.includes(r.id))
    .reduce((s, r) => s + (subtotal * (r.rate || 0)) / 100, 0);
  return (
    <div className="border border-amber-200 bg-amber-50 rounded-md p-3" data-testid={`${testidPrefix}-panel`}>
      <div className="text-xs font-semibold text-amber-800 mb-2 uppercase tracking-wide">
        Potongan Pajak (auto dari partner — bisa diubah)
      </div>
      <div className="space-y-1">
        {taxRegs.map((r) => {
          const checked = selected.includes(r.id);
          const amount = (subtotal * (r.rate || 0)) / 100;
          return (
            <label key={r.id} className="flex items-center gap-2 text-sm cursor-pointer">
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => toggle(r.id, e.target.checked)}
                data-testid={`${testidPrefix}-chk-${r.id}`}
              />
              <span className="font-medium">{r.name}</span>
              <span className="text-slate-500 tabular-nums">({r.rate}%)</span>
              <span className="tabular-nums ml-auto font-medium text-amber-900" data-testid={`${testidPrefix}-amt-${r.id}`}>
                {checked ? formatIDR(amount) : "—"}
              </span>
            </label>
          );
        })}
      </div>
      <div className="mt-2 text-xs text-amber-900 border-t border-amber-200 pt-2 flex justify-between">
        <span>Total potongan pajak:</span>
        <span className="font-semibold tabular-nums" data-testid={`${testidPrefix}-total`}>{formatIDR(totalDed)}</span>
      </div>
    </div>
  );
}
